export default __webpack_public_path__ + "static/media/AddCircle.6e857a5e.svg";